module.exports = __webpack_public_path__ + "img/environment-properties.7d0ed58b.png";